/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'google-plus': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#dd4b39" d="M0 0v32h32V0H0zm18.655 17.346c-.547 3.595-3.227 5.655-6.697 5.655a7.06 7.06 0 010-14.119c1.886 0 3.539.673 4.742 1.841l-2.026 2.026c-.686-.691-1.625-1.06-2.716-1.06-2.295 0-4.156 1.957-4.156 4.252 0 2.296 1.861 4.197 4.156 4.197 1.924 0 3.381-.93 3.801-2.792h-3.801v-2.835h6.68c.08.457.121.935.121 1.43 0 .491-.036.959-.104 1.405zm8.478-.879h-2.474v2.473h-1.757v-2.473h-2.474v-1.758h2.474v-2.474h1.757v2.474h2.474v1.758z"/>'
  }
})
